// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1h72e","colBig":"styles_colBig__L8MaQ","colSmall":"styles_colSmall__fUZDc","shopifyNameWrapper":"styles_shopifyNameWrapper__1WRu7"};